/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { globalSearch } from "../../api/searchApi";
import { RULE_TERM, ruleTerm } from "../../constants/terminology";

const __vue_script__ = {
  name: "GlobalSearch",
  data() {
    return {
      searchText: "",
      projects: [],
      components: [],
      rules: [],
      srgs: [],
      stigs: [],
      stigRules: [],
      srgRules: [],
    };
  },
  computed: {
    // Component search results span both kinds — deployment-default noun.
    // Catalog sections are kind-fixed: published STIG rules, SRG requirements.
    searchPlaceholder() {
      return `Search projects, components, ${RULE_TERM.plural.toLowerCase()}, SRGs, STIGs...`;
    },
    rulesHeader() {
      return RULE_TERM.plural;
    },
    stigRulesHeader() {
      return `STIG ${ruleTerm("stig").plural}`;
    },
    srgRulesHeader() {
      return `SRG ${ruleTerm("srg").plural}`;
    },
    showProjects: function () {
      return this.projects?.length > 0;
    },
    showComponents: function () {
      return this.components?.length > 0;
    },
    showRules: function () {
      return this.rules?.length > 0;
    },
    showSrgs: function () {
      return this.srgs?.length > 0;
    },
    showStigs: function () {
      return this.stigs?.length > 0;
    },
    showStigRules: function () {
      return this.stigRules?.length > 0;
    },
    showSrgRules: function () {
      return this.srgRules?.length > 0;
    },
  },
  watch: {
    searchText: async function (query) {
      // Only search for 2+ character queries
      if (!query || query.trim().length < 2) {
        this.projects = [];
        this.components = [];
        this.rules = [];
        this.srgs = [];
        this.stigs = [];
        this.stigRules = [];
        this.srgRules = [];
        return;
      }

      try {
        // Use new unified search API
        const response = await globalSearch({ q: query, limit: 10 });

        // Transform API response to match expected format
        // projects: [[id, name], ...]
        this.projects = (response.data.projects || []).map((p) => [p.id, p.name]);
        // components: [[id, name], ...]
        this.components = (response.data.components || []).map((c) => [c.id, c.name]);
        // rules: [[id, rule_id, component_id, component_prefix], ...]
        this.rules = (response.data.rules || []).map((r) => [
          r.id,
          r.rule_id,
          r.component_id,
          r.component_prefix || "",
        ]);
        // srgs: [[id, name], ...]
        this.srgs = (response.data.srgs || []).map((s) => [s.id, s.name]);
        // stigs: [[id, name], ...]
        this.stigs = (response.data.stigs || []).map((s) => [s.id, s.name]);
        // stig_rules: keep full objects for rule_id display
        this.stigRules = response.data.stig_rules || [];
        // srg_rules: keep full objects for rule_id display
        this.srgRules = response.data.srg_rules || [];
      } catch (error) {
        // Search failed — clear results to avoid stale data
        // eslint-disable-next-line no-console
        console.error("Global search failed:", error);
        this.projects = [];
        this.components = [];
        this.rules = [];
        this.srgs = [];
        this.stigs = [];
        this.stigRules = [];
        this.srgRules = [];
      }
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-input-group",
    { staticClass: "search-input", attrs: { size: "sm" } },
    [
      _c(
        "b-input-group-prepend",
        { attrs: { "is-text": "" } },
        [_c("b-icon", { attrs: { icon: "search", "aria-hidden": "true" } })],
        1
      ),
      _vm._v(" "),
      _c("b-form-input", {
        attrs: {
          id: "srg-id-search",
          debounce: "300",
          placeholder: _vm.searchPlaceholder,
          "aria-label": _vm.searchPlaceholder,
        },
        model: {
          value: _vm.searchText,
          callback: function ($$v) {
            _vm.searchText = $$v
          },
          expression: "searchText",
        },
      }),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          attrs: {
            triggers: "focus",
            target: "srg-id-search",
            placement: "bottom",
            "custom-class": "srg-id-search-results",
          },
        },
        [
          _c("div"),
          _vm._v(" "),
          _vm.showProjects
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v("Projects")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.projects, function (project) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: project[0],
                          staticClass: "text-truncate",
                          attrs: { href: "/projects/" + project[0] },
                        },
                        [_vm._v(_vm._s(project[1]))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showComponents
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v("Components")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.components, function (comp) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: comp[0],
                          staticClass: "text-truncate",
                          attrs: { href: "/components/" + comp[0] },
                        },
                        [_vm._v(_vm._s(comp[1]))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showRules
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v(_vm._s(_vm.rulesHeader))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.rules, function (rule) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: rule[0],
                          staticClass: "text-truncate",
                          attrs: {
                            href:
                              "/components/" + rule[2] + "?stig_id=" + rule[1],
                          },
                        },
                        [_vm._v(_vm._s(rule[3] + "-" + rule[1]))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSrgs
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v("SRGs")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.srgs, function (srg) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: srg[0],
                          staticClass: "text-truncate",
                          attrs: { href: "/srgs/" + srg[0] },
                        },
                        [_vm._v(_vm._s(srg[1]))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showStigs
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v("STIGs")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.stigs, function (stig) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: stig[0],
                          staticClass: "text-truncate",
                          attrs: { href: "/stigs/" + stig[0] },
                        },
                        [_vm._v(_vm._s(stig[1]))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showStigRules
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v(_vm._s(_vm.stigRulesHeader))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.stigRules, function (rule) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: rule.id,
                          staticClass: "text-truncate",
                          attrs: {
                            href:
                              "/stigs/" +
                              rule.stig_id +
                              "?rule_id=" +
                              encodeURIComponent(rule.rule_id),
                          },
                        },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(rule.rule_id)),
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted ml-1" }, [
                            _vm._v(_vm._s(rule.title)),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSrgRules
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v(_vm._s(_vm.srgRulesHeader))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    _vm._l(_vm.srgRules, function (rule) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: rule.id,
                          staticClass: "text-truncate",
                          attrs: {
                            href:
                              "/srgs/" +
                              rule.srg_id +
                              "?rule_id=" +
                              encodeURIComponent(rule.rule_id),
                          },
                        },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(rule.rule_id)),
                          ]),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted ml-1" }, [
                            _vm._v(_vm._s(rule.title)),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showRules &&
          !_vm.showComponents &&
          !_vm.showProjects &&
          !_vm.showSrgs &&
          !_vm.showStigs &&
          !_vm.showStigRules &&
          !_vm.showSrgRules
            ? _c(
                "b-card",
                {
                  staticClass: "search-card overflow-auto shadow",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    { staticClass: "sticky-top search-card__header" },
                    [_vm._v("No Results")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-9c5390e4_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* popover's custom-class doesn't allow these to be scoped */\n.srg-id-search-results {\n  min-width: 448px;\n  margin-top: 0;\n  border: none;\n}\n.srg-id-search-results > .arrow {\n  display: none;\n}\n.srg-id-search-results > .popover-body {\n  padding: 0;\n}\n", map: {"version":3,"sources":["app/javascript/components/navbar/GlobalSearch.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA8OA,4DAAA;AACA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,UAAA;AACA","file":"GlobalSearch.vue","sourcesContent":["<template>\n  <b-input-group size=\"sm\" class=\"search-input\">\n    <b-input-group-prepend is-text>\n      <b-icon icon=\"search\" aria-hidden=\"true\" />\n    </b-input-group-prepend>\n    <b-form-input\n      id=\"srg-id-search\"\n      v-model=\"searchText\"\n      debounce=\"300\"\n      :placeholder=\"searchPlaceholder\"\n      :aria-label=\"searchPlaceholder\"\n    />\n    <b-popover\n      triggers=\"focus\"\n      target=\"srg-id-search\"\n      placement=\"bottom\"\n      custom-class=\"srg-id-search-results\"\n    >\n      <!-- Render an empty div so that the popover detects the first focus (when there are not yet search results) -->\n      <div />\n      <b-card v-if=\"showProjects\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">Projects</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"project in projects\"\n            :key=\"project[0]\"\n            class=\"text-truncate\"\n            :href=\"`/projects/${project[0]}`\"\n            >{{ project[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showComponents\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">Components</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"comp in components\"\n            :key=\"comp[0]\"\n            class=\"text-truncate\"\n            :href=\"`/components/${comp[0]}`\"\n            >{{ comp[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ rulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in rules\"\n            :key=\"rule[0]\"\n            class=\"text-truncate\"\n            :href=\"`/components/${rule[2]}?stig_id=${rule[1]}`\"\n            >{{ `${rule[3]}-${rule[1]}` }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showSrgs\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">SRGs</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"srg in srgs\"\n            :key=\"srg[0]\"\n            class=\"text-truncate\"\n            :href=\"`/srgs/${srg[0]}`\"\n            >{{ srg[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showStigs\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">STIGs</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"stig in stigs\"\n            :key=\"stig[0]\"\n            class=\"text-truncate\"\n            :href=\"`/stigs/${stig[0]}`\"\n            >{{ stig[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showStigRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ stigRulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in stigRules\"\n            :key=\"rule.id\"\n            class=\"text-truncate\"\n            :href=\"`/stigs/${rule.stig_id}?rule_id=${encodeURIComponent(rule.rule_id)}`\"\n          >\n            <span class=\"font-weight-bold\">{{ rule.rule_id }}</span>\n            <small class=\"text-muted ml-1\">{{ rule.title }}</small>\n          </b-list-group-item>\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showSrgRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ srgRulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in srgRules\"\n            :key=\"rule.id\"\n            class=\"text-truncate\"\n            :href=\"`/srgs/${rule.srg_id}?rule_id=${encodeURIComponent(rule.rule_id)}`\"\n          >\n            <span class=\"font-weight-bold\">{{ rule.rule_id }}</span>\n            <small class=\"text-muted ml-1\">{{ rule.title }}</small>\n          </b-list-group-item>\n        </b-list-group>\n      </b-card>\n      <b-card\n        v-if=\"\n          !showRules &&\n          !showComponents &&\n          !showProjects &&\n          !showSrgs &&\n          !showStigs &&\n          !showStigRules &&\n          !showSrgRules\n        \"\n        no-body\n        class=\"search-card overflow-auto shadow\"\n      >\n        <b-card-header class=\"sticky-top search-card__header\">No Results</b-card-header>\n      </b-card>\n    </b-popover>\n  </b-input-group>\n</template>\n\n<script>\nimport { globalSearch } from \"../../api/searchApi\";\nimport { RULE_TERM, ruleTerm } from \"../../constants/terminology\";\n\nexport default {\n  name: \"GlobalSearch\",\n  data() {\n    return {\n      searchText: \"\",\n      projects: [],\n      components: [],\n      rules: [],\n      srgs: [],\n      stigs: [],\n      stigRules: [],\n      srgRules: [],\n    };\n  },\n  computed: {\n    // Component search results span both kinds — deployment-default noun.\n    // Catalog sections are kind-fixed: published STIG rules, SRG requirements.\n    searchPlaceholder() {\n      return `Search projects, components, ${RULE_TERM.plural.toLowerCase()}, SRGs, STIGs...`;\n    },\n    rulesHeader() {\n      return RULE_TERM.plural;\n    },\n    stigRulesHeader() {\n      return `STIG ${ruleTerm(\"stig\").plural}`;\n    },\n    srgRulesHeader() {\n      return `SRG ${ruleTerm(\"srg\").plural}`;\n    },\n    showProjects: function () {\n      return this.projects?.length > 0;\n    },\n    showComponents: function () {\n      return this.components?.length > 0;\n    },\n    showRules: function () {\n      return this.rules?.length > 0;\n    },\n    showSrgs: function () {\n      return this.srgs?.length > 0;\n    },\n    showStigs: function () {\n      return this.stigs?.length > 0;\n    },\n    showStigRules: function () {\n      return this.stigRules?.length > 0;\n    },\n    showSrgRules: function () {\n      return this.srgRules?.length > 0;\n    },\n  },\n  watch: {\n    searchText: async function (query) {\n      // Only search for 2+ character queries\n      if (!query || query.trim().length < 2) {\n        this.projects = [];\n        this.components = [];\n        this.rules = [];\n        this.srgs = [];\n        this.stigs = [];\n        this.stigRules = [];\n        this.srgRules = [];\n        return;\n      }\n\n      try {\n        // Use new unified search API\n        const response = await globalSearch({ q: query, limit: 10 });\n\n        // Transform API response to match expected format\n        // projects: [[id, name], ...]\n        this.projects = (response.data.projects || []).map((p) => [p.id, p.name]);\n        // components: [[id, name], ...]\n        this.components = (response.data.components || []).map((c) => [c.id, c.name]);\n        // rules: [[id, rule_id, component_id, component_prefix], ...]\n        this.rules = (response.data.rules || []).map((r) => [\n          r.id,\n          r.rule_id,\n          r.component_id,\n          r.component_prefix || \"\",\n        ]);\n        // srgs: [[id, name], ...]\n        this.srgs = (response.data.srgs || []).map((s) => [s.id, s.name]);\n        // stigs: [[id, name], ...]\n        this.stigs = (response.data.stigs || []).map((s) => [s.id, s.name]);\n        // stig_rules: keep full objects for rule_id display\n        this.stigRules = response.data.stig_rules || [];\n        // srg_rules: keep full objects for rule_id display\n        this.srgRules = response.data.srg_rules || [];\n      } catch (error) {\n        // Search failed — clear results to avoid stale data\n        // eslint-disable-next-line no-console\n        console.error(\"Global search failed:\", error);\n        this.projects = [];\n        this.components = [];\n        this.rules = [];\n        this.srgs = [];\n        this.stigs = [];\n        this.stigRules = [];\n        this.srgRules = [];\n      }\n    },\n  },\n};\n</script>\n\n<style>\n/* popover's custom-class doesn't allow these to be scoped */\n.srg-id-search-results {\n  min-width: 448px;\n  margin-top: 0;\n  border: none;\n}\n\n.srg-id-search-results > .arrow {\n  display: none;\n}\n\n.srg-id-search-results > .popover-body {\n  padding: 0;\n}\n</style>\n\n<style scoped>\n.search-card {\n  max-height: 192px;\n  background: var(--vulcan-body-bg);\n  border-color: var(--vulcan-border-color);\n}\n\n.search-card__header {\n  background: var(--vulcan-secondary-bg);\n  color: var(--vulcan-body-color);\n  border-bottom-color: var(--vulcan-border-color);\n}\n\n.search-input {\n  min-width: 320px;\n}\n</style>\n"]}, media: undefined })
,inject("data-v-9c5390e4_1", { source: "\n.search-card[data-v-9c5390e4] {\n  max-height: 192px;\n  background: var(--vulcan-body-bg);\n  border-color: var(--vulcan-border-color);\n}\n.search-card__header[data-v-9c5390e4] {\n  background: var(--vulcan-secondary-bg);\n  color: var(--vulcan-body-color);\n  border-bottom-color: var(--vulcan-border-color);\n}\n.search-input[data-v-9c5390e4] {\n  min-width: 320px;\n}\n", map: {"version":3,"sources":["app/javascript/components/navbar/GlobalSearch.vue"],"names":[],"mappings":";AA+PA;EACA,iBAAA;EACA,iCAAA;EACA,wCAAA;AACA;AAEA;EACA,sCAAA;EACA,+BAAA;EACA,+CAAA;AACA;AAEA;EACA,gBAAA;AACA","file":"GlobalSearch.vue","sourcesContent":["<template>\n  <b-input-group size=\"sm\" class=\"search-input\">\n    <b-input-group-prepend is-text>\n      <b-icon icon=\"search\" aria-hidden=\"true\" />\n    </b-input-group-prepend>\n    <b-form-input\n      id=\"srg-id-search\"\n      v-model=\"searchText\"\n      debounce=\"300\"\n      :placeholder=\"searchPlaceholder\"\n      :aria-label=\"searchPlaceholder\"\n    />\n    <b-popover\n      triggers=\"focus\"\n      target=\"srg-id-search\"\n      placement=\"bottom\"\n      custom-class=\"srg-id-search-results\"\n    >\n      <!-- Render an empty div so that the popover detects the first focus (when there are not yet search results) -->\n      <div />\n      <b-card v-if=\"showProjects\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">Projects</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"project in projects\"\n            :key=\"project[0]\"\n            class=\"text-truncate\"\n            :href=\"`/projects/${project[0]}`\"\n            >{{ project[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showComponents\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">Components</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"comp in components\"\n            :key=\"comp[0]\"\n            class=\"text-truncate\"\n            :href=\"`/components/${comp[0]}`\"\n            >{{ comp[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ rulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in rules\"\n            :key=\"rule[0]\"\n            class=\"text-truncate\"\n            :href=\"`/components/${rule[2]}?stig_id=${rule[1]}`\"\n            >{{ `${rule[3]}-${rule[1]}` }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showSrgs\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">SRGs</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"srg in srgs\"\n            :key=\"srg[0]\"\n            class=\"text-truncate\"\n            :href=\"`/srgs/${srg[0]}`\"\n            >{{ srg[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showStigs\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">STIGs</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"stig in stigs\"\n            :key=\"stig[0]\"\n            class=\"text-truncate\"\n            :href=\"`/stigs/${stig[0]}`\"\n            >{{ stig[1] }}</b-list-group-item\n          >\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showStigRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ stigRulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in stigRules\"\n            :key=\"rule.id\"\n            class=\"text-truncate\"\n            :href=\"`/stigs/${rule.stig_id}?rule_id=${encodeURIComponent(rule.rule_id)}`\"\n          >\n            <span class=\"font-weight-bold\">{{ rule.rule_id }}</span>\n            <small class=\"text-muted ml-1\">{{ rule.title }}</small>\n          </b-list-group-item>\n        </b-list-group>\n      </b-card>\n      <b-card v-if=\"showSrgRules\" no-body class=\"search-card overflow-auto shadow\">\n        <b-card-header class=\"sticky-top search-card__header\">{{ srgRulesHeader }}</b-card-header>\n        <b-list-group flush>\n          <b-list-group-item\n            v-for=\"rule in srgRules\"\n            :key=\"rule.id\"\n            class=\"text-truncate\"\n            :href=\"`/srgs/${rule.srg_id}?rule_id=${encodeURIComponent(rule.rule_id)}`\"\n          >\n            <span class=\"font-weight-bold\">{{ rule.rule_id }}</span>\n            <small class=\"text-muted ml-1\">{{ rule.title }}</small>\n          </b-list-group-item>\n        </b-list-group>\n      </b-card>\n      <b-card\n        v-if=\"\n          !showRules &&\n          !showComponents &&\n          !showProjects &&\n          !showSrgs &&\n          !showStigs &&\n          !showStigRules &&\n          !showSrgRules\n        \"\n        no-body\n        class=\"search-card overflow-auto shadow\"\n      >\n        <b-card-header class=\"sticky-top search-card__header\">No Results</b-card-header>\n      </b-card>\n    </b-popover>\n  </b-input-group>\n</template>\n\n<script>\nimport { globalSearch } from \"../../api/searchApi\";\nimport { RULE_TERM, ruleTerm } from \"../../constants/terminology\";\n\nexport default {\n  name: \"GlobalSearch\",\n  data() {\n    return {\n      searchText: \"\",\n      projects: [],\n      components: [],\n      rules: [],\n      srgs: [],\n      stigs: [],\n      stigRules: [],\n      srgRules: [],\n    };\n  },\n  computed: {\n    // Component search results span both kinds — deployment-default noun.\n    // Catalog sections are kind-fixed: published STIG rules, SRG requirements.\n    searchPlaceholder() {\n      return `Search projects, components, ${RULE_TERM.plural.toLowerCase()}, SRGs, STIGs...`;\n    },\n    rulesHeader() {\n      return RULE_TERM.plural;\n    },\n    stigRulesHeader() {\n      return `STIG ${ruleTerm(\"stig\").plural}`;\n    },\n    srgRulesHeader() {\n      return `SRG ${ruleTerm(\"srg\").plural}`;\n    },\n    showProjects: function () {\n      return this.projects?.length > 0;\n    },\n    showComponents: function () {\n      return this.components?.length > 0;\n    },\n    showRules: function () {\n      return this.rules?.length > 0;\n    },\n    showSrgs: function () {\n      return this.srgs?.length > 0;\n    },\n    showStigs: function () {\n      return this.stigs?.length > 0;\n    },\n    showStigRules: function () {\n      return this.stigRules?.length > 0;\n    },\n    showSrgRules: function () {\n      return this.srgRules?.length > 0;\n    },\n  },\n  watch: {\n    searchText: async function (query) {\n      // Only search for 2+ character queries\n      if (!query || query.trim().length < 2) {\n        this.projects = [];\n        this.components = [];\n        this.rules = [];\n        this.srgs = [];\n        this.stigs = [];\n        this.stigRules = [];\n        this.srgRules = [];\n        return;\n      }\n\n      try {\n        // Use new unified search API\n        const response = await globalSearch({ q: query, limit: 10 });\n\n        // Transform API response to match expected format\n        // projects: [[id, name], ...]\n        this.projects = (response.data.projects || []).map((p) => [p.id, p.name]);\n        // components: [[id, name], ...]\n        this.components = (response.data.components || []).map((c) => [c.id, c.name]);\n        // rules: [[id, rule_id, component_id, component_prefix], ...]\n        this.rules = (response.data.rules || []).map((r) => [\n          r.id,\n          r.rule_id,\n          r.component_id,\n          r.component_prefix || \"\",\n        ]);\n        // srgs: [[id, name], ...]\n        this.srgs = (response.data.srgs || []).map((s) => [s.id, s.name]);\n        // stigs: [[id, name], ...]\n        this.stigs = (response.data.stigs || []).map((s) => [s.id, s.name]);\n        // stig_rules: keep full objects for rule_id display\n        this.stigRules = response.data.stig_rules || [];\n        // srg_rules: keep full objects for rule_id display\n        this.srgRules = response.data.srg_rules || [];\n      } catch (error) {\n        // Search failed — clear results to avoid stale data\n        // eslint-disable-next-line no-console\n        console.error(\"Global search failed:\", error);\n        this.projects = [];\n        this.components = [];\n        this.rules = [];\n        this.srgs = [];\n        this.stigs = [];\n        this.stigRules = [];\n        this.srgRules = [];\n      }\n    },\n  },\n};\n</script>\n\n<style>\n/* popover's custom-class doesn't allow these to be scoped */\n.srg-id-search-results {\n  min-width: 448px;\n  margin-top: 0;\n  border: none;\n}\n\n.srg-id-search-results > .arrow {\n  display: none;\n}\n\n.srg-id-search-results > .popover-body {\n  padding: 0;\n}\n</style>\n\n<style scoped>\n.search-card {\n  max-height: 192px;\n  background: var(--vulcan-body-bg);\n  border-color: var(--vulcan-border-color);\n}\n\n.search-card__header {\n  background: var(--vulcan-secondary-bg);\n  color: var(--vulcan-body-color);\n  border-bottom-color: var(--vulcan-border-color);\n}\n\n.search-input {\n  min-width: 320px;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-9c5390e4"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/navbar/GlobalSearch.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__